import m = require("mithril");
import {Point} from "../../model/utils";
import prop = require("mithril/stream");
import {Vnode} from "mithril";

interface Params {
    events: Events,
    content: any,
    key: any
}

interface Events {
    onMove?: (p:Point) => void,
    onStart?: (p:Point) => void,
    onDrop?: (p:Point, evt: MouseEvent|TouchEvent) => void
}

export class Draggable {
    private element?: HTMLElement;
    private content: any;
    private container: HTMLElement;
    private documentOnMouseUp: any;
    private documentOnMouseMove: any;
    private documentOnTouchMove: any;
    private documentOnTouchEnd: any;
    private events: Events;
    private key: any;

    constructor(attr: Params) {
        this.content = attr.content;
        this.container = <HTMLElement>document.getElementsByClassName("grid")[0];
        this.events = attr.events;
        this.key = attr.key;
    }

    view() {
        return m('div.dragDropItem', {
            key: this.key,
            "data-value": this.key,
            oncreate: (vnode) => {
                this.element = <HTMLElement>vnode.dom;
            },
            onmousedown: (evt: MouseEvent) => this.startMoving(evt),
            ontouchstart: (evt: TouchEvent) => {
                if (evt.touches.length === 1) {
                    evt.preventDefault();
                    this.startMoving(evt)
                }
            }
        }, [
            m('.dragDropItem-inner', {}, this.content),
        ]);
    }

    startMoving(evt: MouseEvent|TouchEvent) {
        evt = evt || <MouseEvent>window.event;
        this.container.style.cursor = 'move';

        this.element?.classList.add('manipulated');


        this.element!.style.zIndex = '1';

        // Real position
        const ePosition = {
            // @ts-ignore element
            x: +this.element.style.left.replace('px', ''),

            // @ts-ignore element
            y: +this.element.style.top.replace('px', '')
        };
        const startPoint = this.evtToPoint(evt);

        const clientRect = this.container.getBoundingClientRect();
        const elementRect = this.element!.getBoundingClientRect();

        // Mouse move events are registered on document so they work on the whole page
        this.backupDocumentCallbacks();
        document.onmousemove = (evt: MouseEvent) => {
            evt = evt || <MouseEvent>window.event;
            let p = this.diffPoints(this.evtToPoint(evt), startPoint);
            p = this.constrainWithinElement(clientRect, elementRect, p);
            p = this.addPoints(p, ePosition);
            this.move(p);
            if( this.events.onMove ) {
                this.events.onMove(this.evtToPoint(evt));
            }
        };
        document.onmouseup = (evt) => {
            this.stopMoving(evt)
        };
        document.ontouchmove = (evt: TouchEvent) => {
            evt = evt || <TouchEvent>window.event;
            let p = this.diffPoints(this.evtToPoint(evt), startPoint);
            p = this.constrainWithinElement(clientRect, elementRect, p);
            p = this.addPoints(p, ePosition);
            this.move(p);
            if( this.events.onMove ) {
                this.events.onMove(this.evtToPoint(evt));
            }
        };
        document.ontouchend = (evt: TouchEvent) => {
            this.stopMoving(evt)
        };
        if( this.events.onStart) {
            this.events.onStart(this.evtToPoint(evt));
        }
        return false;
    }

    stopMoving(evt: MouseEvent|TouchEvent) {
        if( this.events.onDrop) {
            this.events.onDrop(this.evtToPoint(evt), evt);
            this.resetPosition();
        }

        this.element?.classList.remove('manipulated');
        this.container.style.cursor = 'default';
        this.restoreDocumentCallbacks();
        m.redraw();
    }

    private backupDocumentCallbacks() {
        this.documentOnMouseMove = document.onmousemove;
        this.documentOnMouseUp = document.onmouseup;
        this.documentOnTouchMove = document.ontouchmove;
        this.documentOnTouchEnd = document.ontouchend;
    }

    private restoreDocumentCallbacks() {
        document.onmousemove = this.documentOnMouseMove;
        document.onmouseup = this.documentOnMouseUp;
        document.ontouchmove = this.documentOnTouchMove;
        document.ontouchend = this.documentOnTouchEnd;
    }

    private constrainWithinElement(cRect: ClientRect, eRect: ClientRect, p: Point): Point {
        const eRel = this.diffPoints({x: eRect.left, y: eRect.top}, {x: cRect.left, y: cRect.top});
        if (p.x < -eRel.x) {
            p.x = -eRel.x;
        }
        if (p.y < -eRel.y) {
            p.y = -eRel.y;
        }
        if (p.x + eRect.width > -eRel.x + cRect.width) {
            p.x = -eRel.x + cRect.width - eRect.width;
        }
        if (p.y + eRect.height > -eRel.y + cRect.height) {
            p.y = -eRel.y + cRect.height - eRect.height;
        }
        return p;
    }


    private move(p: Point) {
        // @ts-ignore element has style
        this.element.style.left = p.x + 'px';
        // @ts-ignore element has style
        this.element.style.top = p.y + 'px';
    }

    private diffPoints(p1: Point, p2: Point): Point {
        return {x: p1.x - p2.x, y: p1.y - p2.y};
    }
    private addPoints(p1: Point, p2: Point): Point {
        return {x: p1.x + p2.x, y: p1.y + p2.y};
    }

    private evtToPoint(evt: MouseEvent|TouchEvent): Point {
        if (evt instanceof  MouseEvent) {
            return {x: evt.clientX, y: evt.clientY};
        } else {
            const touch = evt.touches[0] || evt.changedTouches[0];
            return {x: touch.clientX, y: touch.clientY};
        }
    }

    private resetPosition() {
        this.move({x:0, y:0})
        this.element!.style.zIndex = '0';
    }
}